export default __webpack_public_path__ + "static/media/pull_payment_top_bg.c3aa6df5.png";